export enum NotificationsEnum {
  TRADE = 'trade',
  OFFER = 'offer',
  ORDER = 'order',
  CHAT = 'chat',
}
